import { INTERNATIONAL_CHECKOUT_FLOW_EXCLUDED_REGIONS } from 'constants/config/region'
import { LE_CONTRACTED_HOTEL_TYPES, OFFER_TYPE_BED_BANK, OFFER_TYPE_VILLA } from 'constants/offer'
import { getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'

/**
 * Per-region minimum member-price savings required to auto-enable the
 * LuxPlus+ toggle in the international checkout flow. Each value is roughly
 * AUD 100 in the region's local currency (savings are denominated in the
 * user's display currency). Missing regions fall back to no auto-add.
 */
export const INTERNATIONAL_CHECKOUT_FLOW_LUX_PLUS_AUTO_ADD_THRESHOLDS: Record<string, number> = {
  AE: 240,
  CA: 92,
  CN: 475,
  HK: 510,
  ID: 1_000_000,
  IL: 245,
  JP: 10_000,
  KR: 90_000,
  MO: 525,
  MY: 290,
  PH: 3_700,
  QA: 240,
  SA: 245,
  SG: 88,
  TH: 2_300,
  TW: 2_100,
  US: 65,
  VN: 1_700_000,
  ZA: 1_200,
}

export function getInternationalCheckoutFlowLuxPlusAutoAddThreshold(regionCode?: string): number | undefined {
  if (!regionCode) return undefined
  return INTERNATIONAL_CHECKOUT_FLOW_LUX_PLUS_AUTO_ADD_THRESHOLDS[regionCode]
}

export function isInternationalCheckoutFlowEligibleRegion(regionCode?: string): boolean {
  return !!regionCode && !INTERNATIONAL_CHECKOUT_FLOW_EXCLUDED_REGIONS.has(regionCode)
}

const INTERNATIONAL_CHECKOUT_FLOW_ELIGIBLE_OFFER_TYPES: Array<App.OfferType> = [
  ...LE_CONTRACTED_HOTEL_TYPES,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_VILLA,
]

export function isInternationalCheckoutFlowEligibleOfferType(offerType?: App.OfferType): boolean {
  return !!offerType && INTERNATIONAL_CHECKOUT_FLOW_ELIGIBLE_OFFER_TYPES.includes(offerType)
}

export function isInternationalCheckoutFlowEligibleUser(params: {
  canRedeemLuxPlusBenefits: boolean
  numberOfPurchases: number | null | undefined
  isSpoofed?: boolean
}): boolean {
  return !params.isSpoofed &&
    !params.canRedeemLuxPlusBenefits &&
    (params.numberOfPurchases ?? 0) === 0
}

export function isInternationalCheckoutFlowVariationEnabled(variation?: string): boolean {
  return !!variation && variation.toLowerCase() !== 'off'
}

export function isInternationalCheckoutFlowTreatmentVariation(variation?: string): boolean {
  return isInternationalCheckoutFlowVariationEnabled(variation) &&
    getExperimentEnabledDecision(variation)
}
